import { useEffect } from "react";
import { Link } from "react-router-dom";
import { Navbar } from "@/components/okaia/Navbar";
import { Footer } from "@/components/okaia/Footer";
import { ArrowRight } from "lucide-react";

export default function NotFoundPage() {
  useEffect(() => {
    document.title = "Page introuvable — OKAÏA Dév";
    return () => {
      document.title = "OKAÏA Dév — Diagnostic Business : clarté et direction en 30 minutes";
    };
  }, []);

  return (
    <main data-testid="not-found-page">
      <Navbar />
      <section className="flex min-h-screen flex-col justify-center bg-[#0B2215] px-6 py-40 md:px-12">
        <div className="mx-auto w-full max-w-[1400px]">
          <p className="okaia-overline mb-8 flex items-center gap-4 text-[#C8A97E]">
            <span className="inline-block h-px w-12 bg-[#C8A97E]" />
            Erreur 404
          </p>
          <p className="font-serif-display text-7xl font-medium italic leading-none text-[#C8A97E] md:text-9xl">404</p>
          <h1 className="mt-8 max-w-3xl font-serif-display text-4xl leading-[1.1] tracking-tight text-[#F9F8F6] sm:text-5xl lg:text-6xl">
            Cette page n'existe pas.
          </h1>
          <p className="mt-6 max-w-xl text-base font-light leading-relaxed text-[#A3B1AA] md:text-lg">
            La page que vous recherchez est introuvable ou n'existe plus. Revenez à l'accueil
            pour retrouver votre direction.
          </p>
          <div className="mt-12 flex flex-col items-start gap-6 sm:flex-row sm:items-center">
            <Link
              to="/"
              data-testid="not-found-home-btn"
              className="group inline-flex items-center gap-3 border border-[#C8A97E] bg-[#C8A97E] px-8 py-4 text-sm font-semibold uppercase tracking-[0.15em] text-[#0B2215] transition-colors duration-300 hover:bg-transparent hover:text-[#C8A97E]"
            >
              Revenir à l'accueil
              <ArrowRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-1.5" />
            </Link>
            <p className="font-serif-display text-sm italic text-[#C8A97E]">
              Voir clair. Décider juste. Développer durablement.
            </p>
          </div>
        </div>
      </section>
      <Footer />
    </main>
  );
}
